<template>
  <div class="vice-chairman">
    <!-- Scroll Spy -->
    <Header></Header>
    <!-- Scroll Spy -->
    <!-- Muddusar challenges -->
    <div class="section introduction">
        <div class="main_content">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 text_container">
                    <div class="left_content">
                        <div class="heading">
                            <h1 data-aos="fade-up" data-aos-duration="1200" v-html="section_one.heading">
                            </h1>
                        </div>
                        <div class="content_main">
                            <p data-aos="fade-up" data-aos-delay="400" data-aos-duration="1500">
                                {{section_one.disc}}
                            </p>
                        </div>
                    </div>
                    </div>
                    <div class="col-lg-5 p-unset">
                    <div class="image_container">
                        <div class="main_image" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="1500">
                            <img :src="require(`../assets/images/vice-chairman/${section_one.img}`)" alt="" class="img-fluid">
                        </div>
                        <div class="title_image">
                            {{section_one.name}}
                        </div>
                        <div class="scroll_icon" title="Click To Scroll Down" v-on:click="scrollDown">
                            <div class="main_icon_parent" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="250" fill="none" stroke = "currentColor" height="250" viewBox="0 0 327 327">
                                    <g id="Group_3" data-name="Group 3"   transform="translate(1152 -216)">
                                        <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(-1152 216)" stroke-width="2">
                                        <circle cx="163.5" cy="163.5" r="163.5" stroke="none"/>
                                        <circle cx="163.5" cy="163.5" r="162.5" />
                                        </g>
                                    </g>
                                </svg>
                                <i class="fa fa-arrow-down"></i>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="section allContent">
    <div class="box_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <div class="main_box" data-aos="fade-right" v-for="(block, index) in section_two" :key="index" v-if="index<=3">
                        <div class="svg_parent">
                            <img src="@/assets/images/vice-chairman/tick.svg" alt="" class="img-fluid">
                        </div>
                        <div class="main_content_">
                            <p v-html="block"></p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="main_box" data-aos="fade-left" v-for="(block, index) in section_two" :key="index" v-if="index>3">
                        <div class="svg_parent">
                            <img src="@/assets/images/vice-chairman/tick.svg" alt="" class="img-fluid">
                        </div>
                        <div class="main_content_">
                            <p v-html="block"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <!-- Muddusar Changes -->
    <div class="sections-wrapper position-relative" sticky-container>
        <div class="sticky" v-sticky="stickyEnabled" sticky-offset="{top: 90, bottom: 0}" sticky-side="both" on-stick="onStick" sticky-z-index="20">
            <!-- <vue-sticky-sidebar class="sidebar" topSpacing=100 containerSelector=".sections-wrapper" innerWrapperSelector='.sectionScrollInner'>
                <div class="sectionScrollInner">
                    <sctionsScroll :page-sections="pageSections"></sctionsScroll>
                </div>
            </vue-sticky-sidebar> -->
            <sctionsScroll :page-sections="pageSections"></sctionsScroll>
        </div>
        <div class="sections-wrapper-inner">
            <div class="section" v-for="counter_block in counter" :id="counter_block.alp" :key="counter_block.id">
                <div class="container">
                    <div class="sectionWrapper">
                        <div class="sectionWrapper__left">
                            <div class="sectionNumber" v-html="counter_block.svg"></div>
                            <div class="sectionNumber__mobile">{{counter_block.id}}</div>
                        </div>
                        <div class="sectionWrapper__right">
                            <div class="row">
                                <div class="col-lg-5">
                                    <div class="section-heading">
                                        <h4 data-aos="fade-up">{{counter_block.title}}</h4>
                                    </div>
                                    <!-- <div class="sub-heading">
                                        <p>Zain Group’s response</p>
                                    </div> -->
                                </div>
                                <div class="col-lg-7">
                                    <div class="inner" v-html="counter_block.desc"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    <div class="tribute">
        <div class="container">
            <div class="title" data-aos="fade-up">{{tribute.title}}</div>
            <div class="row">
                <div class="col-md-4 col-sm-6" data-aos="fade-up">
                    <div class="box">
                        <div class="image">
                            <img src="@/assets/images/tribute/image1.png" class="img-fluid">
                        </div>
                        <div class="detail">
                            <p class="name">{{tribute.name1}}</p>
                            <p class="country">{{tribute.country1}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6" data-aos="fade-up">
                    <div class="box">
                        <div class="image">
                            <img src="@/assets/images/tribute/image2.png" class="img-fluid">
                        </div>
                        <div class="detail">
                            <p class="name">{{tribute.name2}}</p>
                            <p class="country">{{tribute.country2}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6" data-aos="fade-up">
                    <div class="box">
                        <div class="image">
                            <img src="@/assets/images/tribute/image3.png" class="img-fluid">
                        </div>
                        <div class="detail">
                            <p class="name">{{tribute.name3}}</p>
                            <p class="country">{{tribute.country3}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6" data-aos="fade-up">
                    <div class="box">
                        <div class="image">
                            <img src="@/assets/images/tribute/image4.png" class="img-fluid">
                        </div>
                        <div class="detail">
                            <p class="name">{{tribute.name4}}</p>
                            <p class="country">{{tribute.country4}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6" data-aos="fade-up">
                    <div class="box">
                        <div class="image">
                            <img src="@/assets/images/tribute/image5.png" class="img-fluid">
                        </div>
                        <div class="detail">
                            <p class="name">{{tribute.name5}}</p>
                            <p class="country">{{tribute.country5}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6" data-aos="fade-up">
                    <div class="box">
                        <div class="image">
                            <img src="@/assets/images/tribute/image6.png" class="img-fluid">
                        </div>
                        <div class="detail">
                            <p class="name">{{tribute.name6}}</p>
                            <p class="country">{{tribute.country6}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-for="(data, index) in tribute.desc" :key="index">
                 <p data-aos="fade-up">{{data}}</p>
            </div>
           
                
        </div>
    </div>
    <div class="thankyou">
        <div class="container">
            <div class="thankyou__wrapper">
                <div class="row">
                    <div class="col-lg-8">
                    <div class="thankyou-heading">
                        <h5 data-aos="fade-up">{{footer.title}}</h5>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="line" data-aos="fade-up"></div>
                    </div>
                </div>
                <div class="row">
                <div class="col-lg-4">
                    <div class="inner">
                        <div class="inner__img scrollTop" title="Click to scroll Top" v-on:click="scrollUp">
                            <img src="@/assets/images/svg/circle.svg" alt="" class="img-fluid"/>
                            <i class="fas fa-arrow-up"></i>
                        </div>
                    </div>
                    </div>
                    <div class="col-lg-4" v-for="(data, index) in footer.desc" :key="index">
                    <div class="inner">
                        <p>{{data}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
  </div>
</template>

<script>
// import vueStickySidebar from "vue-sticky-sidebar";

import sctionsScroll from "@/components/common/sectionsScroll.vue";
import data from "@/components/vice-chairman/json/data.json";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default {
    components:{
        sctionsScroll,
        //"vue-sticky-sidebar": vueStickySidebar
    },
    
    data(){
        return{
            // section_one:section_one,
            // section_two:section_two,
            // counter:counter,
            // footer:footer,
            stickyEnabled: true,
            pageSections: [
                {
                title: "01",
                title_ar: "01",
                id: "one",
                number:"01"
                },
                {
                title: "02",
                title_ar: "02",
                id: "two",
                number:"02"
                },
                {
                title: "03",
                title_ar: "03",
                id: "three",
                number:"03"
                },
                {
                title: "04",
                title_ar: "04",
                id: "four",
                number:"04"
                },
                {
                title: "05",
                title_ar: "05",
                id: "five",
                number:"05"
                },
                {
                title: "06",
                title_ar: "06",
                id: "six",
                number:"06"
                },
                {
                title: "07",
                title_ar: "07",
                id: "seven",
                number:"07"
                },
                {
                title: "08",
                title_ar: "08",
                id: "eight",
                number:"08"
                },
                {
                title: "09",
                id: "nine",
                number:"09"
                }
            ]
        }
    },
    created(){
        if(this.$i18n.locale=="en"){
            this.section_one = data.en.first_section
            this.section_two = data.en.section_two
            this.counter = data.en.counter_section
            this.tribute = data.en.tribute
            this.footer = data.en.footer
            
            
        }
        else{
            this.section_one = data.ar.first_section
            this.section_two = data.ar.section_two
            this.counter = data.ar.counter_section
            this.footer = data.ar.footer
            this.tribute = data.ar.tribute
            
        }
    },
    methods : {
        scrollDown(){
            let WindowHeight = window.innerHeight;
            document.body.scrollTop = WindowHeight;
            document.documentElement.scrollTop = WindowHeight;
        },
        scrollUp(){
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        gsapAnimation(){
            let endheight = 0;
            let sections = document.querySelectorAll(".sectionWrapper");
            sections.forEach((section)=>{
                var number = section.querySelector(".sectionNumber");
                endheight = section.offsetHeight - number.offsetHeight;
                gsap.timeline({
                    scrollTrigger :{
                        trigger : number,
                        toggleActions : "restart none reverse reverse",
                        start :"center center",
                        end:  "+=" + (endheight),
                        pin : number,
                        pinSpacing: false
                    }
                });
            })
        }
    },
    mounted(){
        this.gsapAnimation();
    }

}
</script>
<style lang="scss">
    [data-page="vice-chairman"]{
        .verticalLabel{
            color:#000;
        }
        p{
            line-height:1.4;
        }
    }
</style>
<style lang="scss" scoped>
.sections-wrapper{
    &::after{
        clear:both;
        // position: absolute;
        content:"";
        display: block;
    }
    .sticky{
        width: 100px !important;
        float: left;
    }
    .sections-wrapper-inner{
        float:right;
        width:calc(100% - 100px);
        .container{
            @media screen and (min-width: 1350px){
                max-width: 1340px;
            }
        }
        @media screen and (max-width:991px){
            float:none;
            width:100%;
        }
    }
    /deep/{
        .vue-sticky-placeholder{
            padding-top: 0px !important;
        }
    }
}
/deep/{
    .inner-wrapper-sticky{
        position: absolute;
    }
    .pageSections{
        .navbar{
            position: static;
            top: 0;
            transform: none;
            .nav-item{
                a{
                    color: #BD84CB;
                    padding-left: 0;
                    margin-left: rem(32px);
                    &:hover{
                        color: #BD84CB;
                    }
                }
                &.active{
                    position: relative;
                    height: max-content;
                    a{
                        color: #9152A1 !important;
                        position: relative;
                        &::before{
                            // content: '';
                            // position: absolute;
                            // width: 2px;
                            // height: 50%;
                            background: #9152A1;
                            // top: 50%;
                            // transform: translateY(-50%);
                            // left: -5px;    
                        }
                    }
                    
                }
            }
        }
    }
    header{
        .menu {
            a{
                color:#000;
            }
            svg{
                fill:#000;
            }
        }
    }
    .verticalLabel{
        color:#000;
        &.right{
            @media screen and (min-width:1600px){
                top:70%;
            }
            top:80%;
        }
    }
}
.vice-chairman{
    background: #E8E8E8;
    overflow:hidden;
    .tribute{
        padding:rem(40px) 0;
        .image{
            text-align: center;
             background:#dadbdc;
            margin:auto;
            padding-top:rem(20px);
            img{
                max-height:275px;
                min-height:275px;
                @media screen and (max-width:991px){
                    max-height:240px;
                    min-height:240px;
                }
            }
        }
        .title{
            font-size:rem(25px);
            text-align:center;
            margin-bottom:rem(30px);
            font-weight:600;
        }
        .box{
            margin-bottom:rem(30px);
            padding-top:rem(16px);
            text-align:center;
            .detail{
                background:#8a8c8e;
                color:#fff;
                padding:rem(20px) rem(10px);
                @include flex(center , center);
                flex-direction:column;
                min-height: 110px;
                p{
                    color:#fff;
                    font-weight:600;
                    font-size:rem(17px);
                    line-height:1.2;
                    margin:0;
                    
                    &.name{
                        font-weight:700;
                        margin-bottom:rem(10px);
                        font-size:rem(18px);
                        @media screen and (max-width:767px){
                            font-size:rem(17px);
                        }
                    }
                }
            }
        }
    }
    .scrollTop{
        position:relative;
        i{
            position: absolute;
            top: 50%;
            left: 50%;
            color: #fff;
            transform: translate(-50%, -50%);
            font-size: 1.4375rem;
        }
    }
    .sectionNumber__mobile{
        font-size:rem(85px);
        color:#000;
        font-weight:900;
        line-height:1;
        @media screen and (min-width:992px){
            display:none;
        }
    }
    .container{
        @media screen and (max-width:1300px) and (min-width:992px){
            padding-left:70px;
        }
    }
    p{
        font-size: rem(18px);
        font-weight: 600;
        color: #707070;
        line-height: 1.7;
    }
   // Muddusar Changes
    .introduction {
        min-height: 100vh;
        @media screen and (max-width:991px){
            min-height:auto;
        }
        .text_container {
            min-height: 100vh;
            display: flex;
            align-items: center;
            .left_content {
                h1 {
                    font-size: rem(60px);
                }
                .content_main {
                    max-width: 550px;
                    margin-top: 30px;
                }
            }
            @media screen and (max-width:1199px){
                .left_content {
                    h1 {
                        font-size: rem(45px);
                    }
                    .content_main {
                        max-width: 400px;
                    }
                }
            }
            @media screen and (max-width:1025px) and (min-width:992px){
                .left_content {
                    h1 {
                        font-size: rem(35px);
                    }
                }
            }
            @media screen  and (max-width:991px){
                min-height:initial;
                .left_content {
                    h1 {
                        font-size: rem(40px);
                    }
                }
            }
            @media screen  and (max-width:575px){
                min-height:initial;
                .left_content {
                    h1 {
                        font-size: rem(30px);
                    }
                }
            }
        }
        .main_content {
            position: relative;
            .p-unset {
                position: unset;
                .image_container {
                    position: absolute;
                    right: 25px;
                    top: 75px;
                    .main_icon_parent{
                        color: rgb(70, 64, 64);
                        position:relative;
                        width:250px;
                        height:250px;
                        i{
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            color:grey;
                            font-size:rem(23px);
                        }
                        &:hover{
                            color: black;
                            svg{
                                fill: #000;
                                height:auto;
                                .arrow{
                                    stroke: #fff;
                                }
                            }
                        }
                    }
                    .main_image {
                        max-width: 460px;
                        position: relative;
                        &::before {
                            background-color: rgba(255, 255, 255, 0.3);
                            backdrop-filter: blur(10px) saturate(100%) contrast(45%)
                                brightness(150%);
                            content: '';
                            height: 50px;
                            position: absolute;
                            width: 100%;
                            border-top: 1px solid rgba(255, 255, 255, 0.8);
                            bottom: 0px;
                        }
                        @media (min-width: 1600px) {
                            max-width: 630px;
                        }
                    }
                    .title_image {
                        position: absolute;
                        bottom: calc(15px / 2);
                        font-size: rem(25px);
                        font-weight: bold;
                        color: #707070;
                        width: 100%;
                        text-align: center;
                    }
                    .scroll_icon{
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: calc(-250px / 2);
                        cursor: pointer;
                    }
                }
            }
            @media screen and (max-width:1600px){
                .p-unset {
                    .image_container {
                        .main_icon_parent{
                            svg{
                                width:100%;
                                height:100%;
                            }
                        }
                        .scroll_icon{
                                left: calc(-170px / 2);
                        }
                    }
                }
            }
            @media screen and (max-width:1600px){
                .p-unset {
                    .image_container {
                        .main_icon_parent{
                            width:125px;
                            height:125px;
                            svg{
                                width:100%;
                                height:100%;
                            }
                        }
                        .scroll_icon{
                                left: calc(-125px / 2);
                        }
                    }
                }
            }
            @media screen and (max-width:991px){
                padding-top:80px;
                .left_content{
                    width:100%;
                    .content_main{
                        max-width:100%;
                    }
                    h1{
                        br{
                            display:none;
                        }
                    }
                }
                .row{
                    flex-direction: column-reverse;
                }
                .p-unset {
                    .image_container{
                        position:static !important;
                        .title_image{
                            position:relative;
                            top: -62px !important;
                        }
                        .main_image{
                            margin:auto auto rem(30px) auto;
                            max-width:350px;
                        }
                        .scroll_icon{
                            display:none;
                        }
                    }
                }
            }
        }
    }
    .allContent {
        p {
            color: #9152a1;
            font-size: 25px;
        }
        .main_box {
            display: flex;
            margin-bottom: rem(40px);
            .svg_parent {
                flex: 0 0 80px;
                max-width: 80px;
                svg {
                    width: 100%;
                    height: auto;
                }
            }
            .main_content_ {
                flex: 1;
                p{
                    margin: unset;
                }
            }
        }
        @media screen and (max-width:991px){
            .main_box {
                .svg_parent{
                    flex: 0 0 35px;
                    max-width: 35px;
                    margin-right:rem(20px);
                }
            }
            p{
                font-size:rem(20px);
            }
        }
        @media screen and (max-width:991px){
            p{
                br{
                    display:none;
                }
            }
        }
    }

// Muddusar Changes
    .section{
        margin-bottom: rem(86px);
        @media screen and (max-width:1199px){
            margin-bottom:rem(230px);
        }
        @media screen and (max-width:991px){
            margin-bottom:rem(50px);
        }
        &.introduction{
            margin-bottom:rem(100px);
            @media screen and (max-width:1800px) and (min-width:1600px){
                margin-bottom:rem(150px);
            }
        }
    .sectionWrapper{
        display: flex;
        justify-content: space-evenly;
        width: 100%;
        padding-right:5px;
        &__left{
            flex:  0 0 25%;
            margin: rem(100px) rem(0px);
            margin-bottom: 0px;
            .sectionNumber{
                font-size: rem(200px);
                font-weight: 700;
                color: #000000;
                svg{
                    fill:#000;
                    stroke:none;
                }
                
            }
            @media screen and (max-width:1600px){
                flex:  0 0 20%;
                .sectionNumber{
                    font-size:rem(150px);
                    svg{
                        width:250px;
                        height:auto
                    }
                }
                    
            }
             @media screen and (max-width:1199px){
                .sectionNumber{
                    font-size:rem(120px);
                    svg{
                        width:160px;
                    }
                }
                    
            }
             @media screen and (max-width:991px){
                 margin: 0 0 rem(20px) 0;
                flex: none !important;
                width: 100% !important;
                .sectionNumber{
                    display:none !important;
                }
                    
            }
        }
        &__right{
            flex:1;
            border-top: 5px solid black;
            padding-top: rem(10px);
           @media screen and (max-width:991px){
               border-top: 2px solid black;
           }
            .section-heading{
                margin-top: rem(60px);
                @media screen and (max-width:767px){
                    margin-top:rem(30px);
                }
                h4{
                    font-size: rem(45px);
                    line-height: 1.3;
                    font-weight: 700;
                    color: #000000;
                    @media screen and (max-width:1600px) {
                        font-size: rem(35px);
                        
                    }
                    @media screen and (max-width:1199px) and (min-width:992px) {
                        font-size: rem(30px);
                        
                    }
                    @media screen and (max-width:767px) {
                        font-size: rem(28px);
                        
                    }
                }
            }
            .sub-heading{
                margin-top: rem(30px);
                @media screen and (max-width:767px){
                    margin-top:rem(20px);
                }
                p{
                    font-size: rem(24px);
                    font-weight: 600;
                    color: #000000;
                }
            }
            .inner{
                margin-top: rem(60px);
                margin-right: rem(50px);
                padding-left: rem(8px);
                @media screen and (max-width:991px){
                    margin:rem(20px) 0 0 0;
                }
            }    
        }
        @media screen and (max-width:991px){
            flex-direction: column;
        }   
    }    
}
.thankyou{
    background: #000000;
    .thankyou__wrapper{
        .last-p{
            text-align: center;
            padding: rem(25px) 0rem; 
            color: white;
            margin: unset;
        }
        .thankyou-heading{
            margin-top: 30px;
            h5{
                font-size: rem(120px);
                font-weight: 700;
                color: #ffffff;
                @media screen and (max-width:1600px){
                    font-size:rem(90px);
                }
                @media screen and (max-width:1199px){
                    font-size:rem(70px);
                }
                @media screen and (max-width:991px){
                    font-size:rem(50px);
                }
                @media screen and (max-width:767px){
                    font-size:rem(30px);
                }
            }
        }
        .line{
            width : 100%;
            height: 5px;
            margin-top: rem(100px);
            background: white;
            @media screen and (max-width:991px){
                height: 2px;
                margin-top: rem(30px);
            }
        }
        .inner{
            margin-top: rem(60px);
            margin-right: rem(50px);
            padding-left: rem(8px);
            @media screen and (max-width:991px){
                margin-top:rem(20px);
                margin-right:0;
            }
            .inner__img{
                margin-top: rem(70px);
                width: 250px;
                height: 250px;
                transition: all .5s;
                @media screen and (max-width:1600px){
                    width:125px;
                    height:125px;
                }
                @media screen and (max-width:991px){
                    width:80px;
                    height:80px;
                    margin-top:rem(20px);
                }
                    &:hover{
                        cursor: pointer;
                        transform: translateY(-20px);
                    }
                }
            }
            @media screen and (max-width:991px) {
                .row{
                    &:last-child{
                        .col-lg-4:first-child{
                            order: 3;
                        }
                    }
                }
            }
        }

    }
}

[lang="ar"]{
    .sections-wrapper{
        .sticky{
            float: right;
            right:0 !important;
        }
        .sections-wrapper-inner{
            float:left;
        }
    }
    /deep/{

        .pageSections{
            .navbar{
                .nav-item{
                    a{
                        color: #BD84CB;
                        padding-right: 0;
                        margin-right: rem(32px);
                        margin-left:0;
                    }
                }
            }
        }
    }
    .vice-chairman{
        .container{
            @media screen and (max-width:1300px) and (min-width:992px){
                padding-right:70px;
                padding-left:30px;
            }
        }
        .introduction {
            .main_content {
                .p-unset {
                    .image_container {
                        position: absolute;
                        left: 25px;
                        right:auto;
                        .scroll_icon{
                            right: calc(-250px / 2);
                            left:auto;
                        }
                    }
                }
                @media screen and (max-width:1600px){
                    .p-unset {
                        .image_container {
                            .scroll_icon{
                                right: calc(-170px / 2);
                                left:auto;
                            }
                        }
                    }
                }
                @media screen and (max-width:1600px){
                    .p-unset {
                        .image_container {
                            .scroll_icon{
                                right: calc(-125px / 2);
                                left:auto;
                            }
                        }
                    }
                }
            }
        }
        .allContent {

            @media screen and (max-width:991px){
                .main_box {
                    .svg_parent{
                        margin-left:rem(20px);
                        margin-right:0;
                    }
                }
            }
        }
    .section{
        .sectionWrapper{
            padding-left:5px;
            padding-right:0;
            &__right{
                .inner{
                    margin-left: rem(50px);
                    margin-right: 0;
                    padding-right: rem(8px);
                    padding-left:0;
                    @media screen and (max-width:991px){
                        margin:rem(20px) 0 0 0;
                    }
                }    
            }
            &__left{
                direction:ltr;
            } 
        }    
    }
    .thankyou{
        .thankyou__wrapper{
            .inner{
                margin-left: rem(50px);
                margin-right:0;
                padding-right: rem(8px);
                padding-left:0;
                @media screen and (max-width:991px){
                    margin-left:0;
                }
                } 
            }

        }
    }
}


</style>